import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomItemOrderDto } from './bom-item-order.dto';

@Injectable({ providedIn: 'root' })
export class BomItemOrdersProvider {
  constructor(private http: HttpClient) {}

  getOrders(bomItemId: number): Observable<BomItemOrderDto[]> {
    const url = `/api/bom/${bomItemId}/production-orders`;
    return this.http.get<BomItemOrderDto[]>(url);
  }
}
